import "./lib/sentry";
import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import { ConvexProvider, ConvexReactClient } from "convex/react";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import { ThemeProvider } from "./contexts/theme-context";
import "./index.css";

const convexUrl = import.meta.env.VITE_CONVEX_URL || "https://robust-labrador-493.convex.cloud";
const convex = new ConvexReactClient(convexUrl);

if (typeof window !== "undefined" && import.meta.env.DEV) {
  (window as unknown as { __convex?: ConvexReactClient }).__convex = convex;
}

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary
    fallback={
      <div className="min-h-screen flex items-center justify-center bg-background p-6">
        <div className="max-w-md w-full text-center">
          <h1 className="text-2xl font-bold text-foreground mb-3">Something went wrong</h1>
          <p className="text-muted-foreground mb-6">
            An unexpected error occurred. Please refresh the page to try again.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary/90 transition-colors"
          >
            Refresh page
          </button>
        </div>
      </div>
    }
  >
    <HelmetProvider>
      <ThemeProvider>
        <ConvexProvider client={convex}>
          <App />
        </ConvexProvider>
      </ThemeProvider>
    </HelmetProvider>
  </Sentry.ErrorBoundary>
);
